import CryptoJS from 'crypto-js';
import EnvConfig from 'env.config';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { getStorageSetting } from '../storage';
import { getPiiValidationCodes } from './getPiiValidationCodes';

export const USER_CONFIG_REQUEST = 'USER_CONFIG_REQUEST';
export const USER_CONFIG_SUCCESS = 'USER_CONFIG_SUCCESS';
export const USER_CONFIG_FAILURE = 'USER_CONFIG_FAILURE';

function request() {
  return {
    type: USER_CONFIG_REQUEST
  };
}

function receive(data) {
  let permissions = null;
  let noActiveClients = false;
  let jsonObject = null;

  if (data) {
    const key = sessionStorage.getItem(EnvConfig.tokenName);
    const decryptedArray = CryptoJS.AES.decrypt(data, key.substring(64, 96));
    const decryptedText = decryptedArray.toString(CryptoJS.enc.Utf8);
    jsonObject = JSON.parse(decryptedText);

    if (jsonObject && (!jsonObject.clients || jsonObject.clients.length === 0)) {
      noActiveClients = true;
    }

    const currentSettings = getStorageSetting();
    if (currentSettings && currentSettings.selectedClient) {
      if (jsonObject.clients) {
        const newSelectedClient = jsonObject.clients.filter(x => x.key === currentSettings.selectedClient.key);
        if (newSelectedClient && newSelectedClient.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          jsonObject.selectedClient = newSelectedClient[0];
        } else {
          jsonObject.selectedClient = currentSettings.selectedClient;
        }
      } else {
        jsonObject.selectedClient = currentSettings.selectedClient;
      }

      data = CryptoJS.AES.encrypt(JSON.stringify(jsonObject), key.substring(64, 96));
    }

    sessionStorage.setItem(EnvConfig.firstTokenName, key);
    sessionStorage.setItem(EnvConfig.optionsName, data);

    if (jsonObject.permissions) {
      permissions = JSON.parse(JSON.stringify(jsonObject.permissions));
      delete data.permissions;
    } else {
      permissions = null;
    }
  }

  return {
    type: USER_CONFIG_SUCCESS,
    username: jsonObject.username,
    settings: jsonObject,
    permissions,
    noActiveClients
  };
}

function reject() {
  return {
    type: USER_CONFIG_FAILURE
  };
}

export function getUserConfig() {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .getUserConfig()
      .then((response) => {
        const decryptedData = receive(response.data);
        dispatch(decryptedData);
        if (decryptedData.settings.selectedClient && decryptedData.settings.selectedClient.isPiiProtectionEnabled) {
          dispatch(getPiiValidationCodes());
        }
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
